import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CollectionService } from '@services/collection.service';
import { ConfigService } from '@services/config.service';
import { RoleManagementService } from '@services/role.management.service';
import { UserService } from '@services/user.service';
import { timer, Subscription } from 'rxjs';
import { RoleManagement } from '@configs/role.config';
import { IdleService } from 'src/app/shared/idle.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { counterTime } from '@configs/questions.config';
import { Router } from '@angular/router';
@Component({
  selector: 'app-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.scss']
})
export class TwoFactorAuthenticationComponent implements OnInit {
  fullyear = new Date().getFullYear();
  twoFactorAuth: FormGroup;
  submitted = false;
  collectionData$: Subscription | undefined;
  loginErrorMessage: string;
  isDisplayError: boolean = false;
  countDown: Subscription;
  counter = counterTime.counter;
  isEnable: boolean = true;
  isValid: boolean = false;
  userData: any;
  constructor(public configService: ConfigService,
    public fb: FormBuilder, public UserService: UserService,
    private roleSer: RoleManagementService,
    private collectionService: CollectionService,
    public idleService: IdleService,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
    public router: Router ) { }

  ngOnInit(): void {
    this.countDownFun();

    this.twoFactorAuth = this.fb.group({
      code : ['', [
        Validators.required,
        Validators.maxLength(6),
        Validators.pattern('^[0-9]*$')
      ]],
    });

    this.userData = JSON.parse(localStorage.getItem('userData'));
  }

  get f() { return this.twoFactorAuth.controls; }

  signIn() {
    this.submitted = true;

    if (this.twoFactorAuth.valid) {
      this.isValid = true;
      let payload = {
        "emailId": this.userData.email,
        "authorizationCode": this.twoFactorAuth.value.code
      }

      this.UserService.verfiyAuthCode(payload).subscribe(data => {
        if (data.status == 'true') {
          if (this.userData.isTempPassword == true || localStorage.getItem('resetPassword') == 'true') {
            this.router.navigate(['/changePassword']);
          } else {
            let loginPayload = {
              "emailId": this.userData.email,
              "password": this.userData.password
            }
            const rememberMe = localStorage.getItem('rememberMe')
            this.UserService.signIn(loginPayload).subscribe((data) => {
              if (data.status != 'false') {
                localStorage.clear();
                const langId = data.data.langId;
                langId ? localStorage.setItem('langId',langId) : localStorage.setItem('langId','1');
                const langCode = data.data.languagecode;
                langCode !== undefined ? localStorage.setItem('language',langCode) : null;
                localStorage.setItem('currentUser', JSON.stringify(data.data));
                if(rememberMe){
                  localStorage.setItem('rememberMe', rememberMe)
                }
                this.roleSer.startRoleManagement();

                this.collectionData$ = this.collectionService.getCollection()?.subscribe((collectionData: any) => {
                  let collections = collectionData?.data;
                  sessionStorage.removeItem('aiToken');
                  if (collectionData.data && collectionData.data.length > 0) {
                    sessionStorage.defaultcollectionid = JSON.stringify(collections[0].collectionid);
                    sessionStorage.defaultcollectionuuid = JSON.stringify(collections[0].collectionuuId);
                    localStorage.defaultcollectionid = JSON.stringify(collections[0].collectionid);
                    localStorage.defaultcollectionuuid = JSON.stringify(collections[0].collectionuuId);
                    this.roleSer.getAccessDetails(RoleManagement.Items, true);
                  }

                  this.resetIdealLogoutFlag();
                },
                  (error: any) => {
                    this.isValid = false;
                    this.webErrorService.handleAPIErrors(error);
                  });
              } else {
                this.isValid = false;
                this.isDisplayError = false;
                this.loginErrorMessage = data.message;
              }
            },
            error => { this.loginErrorMessage = error.error.message; });
          }
        }
      }, error => { this.isValid = false; this.loginErrorMessage = error.error.message; });
    }
  }

  countDownFun() {
    this.countDown = timer(0, 1000).subscribe(() => {
      --this.counter
      if (this.counter === 0) {
        this.isEnable = false;
        this.countDown.unsubscribe();
      }
    });
  }

  resendAuthenticationCode() {
    let payload = {
      "emailId":this.userData.email,
      "password":this.userData.password
    }

    this.UserService.resendAuthenticationCode(payload).subscribe(data =>{
      if (data.status != 'true') {
        this.isDisplayError = false;
        this.loginErrorMessage = data.message;
      } else  {
        this.isEnable = true;
        this.counter = counterTime.counter;
        this.countDownFun();
      }
    });
  }

  resetIdealLogoutFlag(): void {
    this.idleService.showIdealLogoutMessage = false;
    localStorage.removeItem('Idle_logout');
  }
}
